// EL VISOR DE DOCUMENTOS DE TODA LA APLICACIÓN, montado una sola vez en App.jsx (27-sep-2026).
//
// Escucha el evento de utils/verDocumento: quien quiere enseñar un documento DENTRO de la app nativa (utils/abrirArchivo,
// cuando no hay pestañas a las que ir) le pasa el fichero, y aquí se abre en components/VisorDocumento. La dirección
// temporal del fichero se crea aquí y se suelta al cerrar, o al abrir otro encima.
//
// LAS FOTOS VAN AL VISOR DE IMÁGENES (30-sep-2026, la Nube fase 2): una imagen que llegaba aquí salía como «Este tipo de
// archivo no se puede ver dentro de la aplicación». Ahora cualquier `image/*` (menos el SVG, que puede llevar código) se
// enseña en components/VisorImagen, con su zoom y sus cuatro formas de cerrarse; lo demás, en VisorDocumento como antes.
import { useEffect, useState } from 'react'
import VisorDocumento from './VisorDocumento'
import VisorImagen from './VisorImagen'
import { EVENTO_VER_DOCUMENTO } from '../utils/verDocumento'
import { t } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const esImagenVisible = (mime) => /^image\//i.test(String(mime || '')) && !/svg/i.test(String(mime || ''))

const soltar = (src) => { try { if (src) URL.revokeObjectURL(src) } catch { /* nada */ } }

export default function VisorDocumentoGlobal() {
  const [doc, setDoc] = useState(null)
  useEffect(() => {
    const abrir = (e) => {
      const d = e && e.detail
      if (!d || !d.blob) return
      setDoc((antes) => {
        if (antes) soltar(antes.src)
        return { src: URL.createObjectURL(d.blob), nombre: d.nombre, mime: d.mime }
      })
    }
    window.addEventListener(EVENTO_VER_DOCUMENTO, abrir)
    return () => window.removeEventListener(EVENTO_VER_DOCUMENTO, abrir)
  }, [])
  if (!doc) return null
  const cerrar = () => { soltar(doc.src); setDoc(null) }
  if (esImagenVisible(doc.mime)) return <VisorImagen src={doc.src} alt={doc.nombre || t('components.VisorDocumentoGlobal.imagen', 'Imagen')} onClose={cerrar} />
  return <VisorDocumento src={doc.src} nombre={doc.nombre} mime={doc.mime} onClose={cerrar} />
}
